export default __webpack_public_path__ + "static/media/ls.8d714054.svg";